// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"9e75c819","65":"56922ff2","224":"0d880e5d","295":"e71cd1fa","303":"e817ab11","304":"ab75dc81","786":"de84459a","799":"46f1f63e","923":"24c66fa9"}[chunkId] + ".chunk.css";
};